export const ERROR_CODES = [
    'request.executionDeadline',
    // Axiom
    'axiom.queryRejected',
    'axiom.tokenInvalid',
    // Invite
    'invite.emailSendFailed',
    'invite.linkNotFound',
    'invite.linkExpired',
    'invite.authMethodNotAllowed',
    'invite.userAlreadyExists',
    'invite.userNotFoundInAuth0',
    'invite.orgMaxUsers',
    'invite.fleetClientRequired',
    'invite.fleetModuleRequired',
    'invite.fleetClientWithoutPortalRole',
    'invite.portalRolesExclusive',
    'invite.userAlreadyInOrg',
    // User
    'user.notFound',
    'user.alreadyExists',
    'user.phoneAlreadyTaken',
    'user.ssoIdentityNotVerified',
    'user.ssoIdentityCollision',
    'user.identityDisabled',
    // Password reset
    'reset.linkExpired',
    'reset.linkInvalid',
    'reset.ssoUser',
    // Email
    'email.attachmentTooLarge',
    'email.domainNotVerified',
    'email.invalidRecipient',
    'email.providerRejected',
    'email.providerUnavailable',
    'email.unknown',
    // Training record
    'trainingRecord.currentTrainingPeriodNotFound',
    // Handling party
    'handlingParty.alreadyExists',
    'recordNotFound',
    // Claim status
    'claimStatus.alreadyExists',
    'unauthorized',
    // Communication template
    'commTemplate.alreadyExists',
    // Communication signature
    'commSignature.alreadyExists',
    // Product type
    'productType.alreadyExists',
    // Product type state (CUR-473)
    'productTypeState.alreadyExists',
    // Product
    'product.alreadyExists',
    // Product version
    'productVersion.alreadyExists',

    // Product version — contact types
    'productVersionContactType.alreadyExists',
    'productVersionContactType.roleTaken',
    'productVersionContactType.roleAlreadyOnVersion',
    'orgContactRole.alreadyExists',
    'orgContactRole.roleInUse',
    // Product version — form field mappings
    'productVersionFieldMapping.targetTaken',
    'productVersionFieldMapping.batchTimedOut',
    // Product version — export and import as a bundle (CUR-1893)
    'productVersionBundle.confirmationRequired',
    // Lodgement v2 public surface (docs/plan/product-version-public-lodgement/lodgement-v2-design.md § 4)
    'lodgement.formChanged',
    'lodgement.validationFailed',
    'lodgement.draftNotEditable',
    'lodgement.linkPaused',
    'lodgement.fileLimitReached',
    'lodgement.fileTypeNotAccepted',
    'lodgement.fileTooLarge',
    // Deferred product binding (CUR-2160)
    'claimBinding.versionNotPublished',
    'claimBinding.notAwaitingProduct',
    'claimBinding.productRequired',
    // Closing a claim with an outcome (CUR-2167)
    'claimClosure.notOpen',
    'claimClosure.chooseStatus',
    'claimClosure.noClosedStatus',
    'claimClosure.outcomeNeedsProduct',
    'claimClosure.outcomeHasMoney',
    'claimClosure.duplicateTarget',
    // AI claim lodgement from documents (CUR-1742)
    'aiLodgement.fileType',
    'aiLodgement.emailTooLarge',
    'aiLodgement.tooManyFiles',
    'aiLodgement.runTooLarge',
    'aiLodgement.noFiles',
    'aiLodgement.runNotUploading',
    'aiLodgement.runEnded',
    'aiLodgement.notAwaitingProduct',
    'aiLodgement.productBeingChosen',
    'aiLodgement.productAlreadyChosen',
    'aiLodgement.incidentAlreadyChosen',
    'aiLodgement.draftUnavailable',
    'aiLodgement.notReady',
    'aiLodgement.alreadyLodged',
    'aiLodgement.notPrefilling',
    'aiLodgement.productLocked',
    'aiLodgement.draftReplaced',
    'aiLodgement.attachingToClaim',
    'aiLodgement.attachInProgress',
    'aiLodgement.runBeingLodged',
    'aiLodgement.filesGone',
    'aiLodgement.singleIncident',
    'aiLodgement.uploadMissing',
    // A claim recorded from a run without a product (CUR-2166): the run changed while it was recorded.
    'aiLodgement.runChanged',
    // Catastrophe event
    'catastropheEvent.alreadyExists',
    // Org email ID (AI inbox / managed inbound local part — docs/plan/ai-inbox-self-service)
    'org.emailIdAlreadyExists',
    'org.emailIdPreviouslyHeld',
    'org.emailIdNotAvailable',
    'org.logoUnavailable',
    // Register (CUR-644)
    'register.templateAlreadyInstalled',
    'register.nameTaken',
    'register.duplicateFieldLabel',
    'register.staleBuilderPayload',
    'register.orgRegisterCapReached',
    // Register delete / restore (CUR-1232)
    'register.registerDeleted',
    'register.registerNotDeleted',
    // Register records (CUR-644 phase 3)
    'register.unknownField',
    'register.archivedField',
    'register.invalidFieldValue',
    'register.requiredFieldMissing',
    'register.recordBinned',
    'register.recordNotBinned',
    // Register record links (CUR-644 phase 4)
    'register.linkAlreadyExists',
    'register.linkGroupFull',
    // Register CSV import/export (CUR-644 phase 7)
    'register.importChangedSincePreview',
    'register.importValidationFailed',
    'register.importRowCapExceeded',
    'register.importMappingInvalid',
    'register.exportRowCapExceeded',
    'register.exportTooLarge',
    'register.registerBusy',
    // Register snapshots (CUR-644 phase 6)
    'register.snapshotNameTaken',
    'register.snapshotCapReached',
    // Scheduled snapshots (CUR-722)
    'register.snapshotScheduleNameTaken',
    'register.snapshotScheduleCapReached',
    'register.snapshotScheduleStartInPast',
    'register.snapshotScheduleBusy',
    'register.snapshotScheduleSpent',
    'register.snapshotScheduleOwnerInactive',
    'register.snapshotOccurrenceCaptured',
    'register.snapshotTooLarge',
    // Scheduled user attestations (CUR-858)
    'userAttestation.scheduleBusy',
    'userAttestation.scheduleSendDateInPast',
    'userAttestation.scheduleSpent',
    'userAttestation.scheduleOwnerInactive',
    'userAttestation.scheduleOccurrenceIssued',
    'userAttestation.scheduleCapReached',
    // Claim flag
    'claimFlag.alreadyExists',
    // Claims authority (CUR-1633)
    'claimAuthorityLevel.alreadyExists',
    'claimAuthorityLevel.inUse',
    'claimAuthority.managerNotAvailable',
    'claimAuthority.reportingLineLoop',
    // Claims authority enforcement (CUR-1641)
    'claimAuthority.noLevel',
    'claimAuthority.changePending',
    // Deciding a held reserve change (CUR-1642)
    'claimAuthority.alreadyDecided',
    'claimAuthority.notAssignee',
    'claimAuthority.ownRequest',
    'claimAuthority.needsInsurer',
    'claimAuthority.notReferral',
    'claimAuthority.claimClosed',
    'claimAuthority.nobodyToResend',
    // Complaint flag
    'complaintFlag.alreadyExists',
    // Incident flag
    'incidentFlag.alreadyExists',
    // Incident submission idempotency — the submission identity was already
    // completed with different details (typically from another tab or device).
    'incident.submissionConflict',
    /**
     * Financials
     */
    // Transaction type
    'transactionType.alreadyExists',
    // Compensation payment
    'compensationPayment.totalAmountGreaterThanRemainingReserveAmount',
    // Excess payment
    'excessPayment.totalExcessAmountGreaterThanPaymentItemsTotalAmount',
    // Vehicle assessment (Clear21) — signals that a correlation row was persisted
    // for this attempt (sent-pending or failed), so the client should dismiss the
    // form and refetch. Its ABSENCE on a PRECONDITION means nothing was recorded
    // (e.g. a pre-persistence repairer-resolution failure), so the form stays open.
    'vehicleAssessment.requestRecorded',
    // Another manual or automatic request currently owns the claim-scoped lease.
    'vehicleAssessment.requestInProgress',
    // The claim's excess outcome moved off the coordinated evaluation between
    // dispatch reservation and assessment persistence — nothing was recorded.
    'vehicleAssessment.staleExcessOutcome',
    // Vehicle inspection (Ravin) — a paid run was refused because the claim already
    // holds a Clear21 repair quote and the handler had not acknowledged it (CUR-1237).
    // Nothing was sent; the form shows the quote and asks again.
    'vehicleInspection.existingRepairQuote',
    // AI pre-send sanitisation (CUR-1730) — an interactive AI action was blocked because
    // personal information could not be replaced before the provider call. Thrown as a
    // PRECONDITION with the fixed message "AI is temporarily unavailable"; the client matches
    // on this id, not the message, to show its own copy.
    'ai.temporarilyUnavailable',
    // Organisation settings — expected refusals of a control-centre save or reset: the value
    // moved on since the editor loaded it (CONFLICT), or it fails the setting's rules
    // (BAD_REQUEST). The editor shows both itself, so neither end reports them to Sentry.
    'orgSetting.stale',
    'orgSetting.invalidValue',
    // Obligation versions (CUR-2023) — publishing a new version was refused because an older
    // version of the same obligation is still awaiting review or in draft. Thrown as a
    // PRECONDITION with a message naming that version; nothing was changed. The client matches on
    // this id to keep the designed refusal out of Sentry.
    'obligation.olderVersionUnpublished',
    // Captcha (CUR-1962) — a public request refused because no Turnstile challenge passed, thrown
    // as UNAUTHORIZED. When the server keeps it out of Sentry, the client matches on this id to
    // leave it to the server too, and still reports a quiet session refusal, which it alone can judge.
    'captcha.rejected',
] as const;

export type CuriumErrorCode = (typeof ERROR_CODES)[number];

/**
 * Expected outcomes of validating a password reset link: the user followed a used,
 * expired or SSO-account link. The server throws them with `captureInSentry: false`
 * and the client classifier skips capture for the same codes.
 */
export const PASSWORD_RESET_LINK_ERROR_CODES = [
    'reset.linkExpired',
    'reset.linkInvalid',
    'reset.ssoUser',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected outcomes of setting a person's claims authority (CUR-1633): the server refuses the
 * chosen manager with `captureInSentry: false` and the panel shows the reason on the field. The
 * reporting-loop message names the people on the line, so the client classifier skips capture too.
 */
export const CLAIM_AUTHORITY_MANAGER_ERROR_CODES = [
    'claimAuthority.reportingLineLoop',
    'claimAuthority.managerNotAvailable',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected refusals of a reserve change under claims-authority enforcement (CUR-1641). The
 * pending-change message names the person the change is waiting on, so neither side captures it.
 */
export const CLAIM_AUTHORITY_RESERVE_CHANGE_ERROR_CODES = [
    'claimAuthority.noLevel',
    'claimAuthority.changePending',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected refusals when deciding or re-sending a held reserve change (CUR-1642), or recording the
 * insurer's approval of a referral (CUR-1643). Several name the person the change is waiting on,
 * so neither side captures them.
 */
export const CLAIM_AUTHORITY_DECISION_ERROR_CODES = [
    'claimAuthority.alreadyDecided',
    'claimAuthority.notAssignee',
    'claimAuthority.ownRequest',
    'claimAuthority.needsInsurer',
    'claimAuthority.notReferral',
    'claimAuthority.claimClosed',
    'claimAuthority.nobodyToResend',
] as const satisfies readonly CuriumErrorCode[];

/** Deadline expiry does not imply rollback of an in-progress mutation. */
export const EXECUTION_DEADLINE_MESSAGE =
    'This request took too long. Work may still finish. Check the outcome before trying again.';
